export const GOTO_NAV = 'GOTO_NAV';
export const GOTO_SECTION = 'GOTO_SECTION';
export const NOOP = 'NOOP';
export const PONIES = 'PONIES';
export const SET_LANG = 'SET_LANG';
export const WHEEL = 'WHEEL';

export function keyDown(keyCode) {
  switch (keyCode) {
    case 37:
      return {
        type: GOTO_NAV,
      };
    case 39:
      return {
        type: GOTO_SECTION,
      };
    default:
      return {
        type: NOOP,
        payload: keyCode,
      };
  }
}

export function navOnlyFromUri(uri) {
  const tokenizedUri = uri.split('/');
  return {
    type: (tokenizedUri.length < 3 || tokenizedUri[2].length === 0) ? GOTO_NAV : GOTO_SECTION,
  };
}



// WEBPACK FOOTER //
// ./common/actions/navigation.js